module.exports = __webpack_public_path__ + "img/Chotu.913329d4.png";